import { useContext, useState, createContext, useEffect } from 'react';

const defualtValue = {};
// initialize customer context
const CustomerContextValue = createContext(defualtValue);
const CustomerContextSetState = createContext(() => null);

function CustomerProvider({ children, customer = defualtValue }) {
  const [_customer, setCustomer] = useState(customer);

  useEffect(() => {
    setCustomer(customer);
  }, [customer]);
  return (
    <CustomerContextValue.Provider value={_customer}>
      <CustomerContextSetState.Provider value={setCustomer}>
        {children}
      </CustomerContextSetState.Provider>
    </CustomerContextValue.Provider>
  );
}

function useCustomerState() {
  const customer = useContext(CustomerContextValue);
  const setCustomer = useContext(CustomerContextSetState);
  const state = [customer, setCustomer];
  return state;
}

function useCustomerValue() {
  const customer = useContext(CustomerContextValue);
  return customer;
}

function useIsCustomer() {
  const customer = useContext(CustomerContextValue);
  if (customer === undefined) {
    return false;
  }
  const isCustomer = !!customer;
  return isCustomer;
}

function useCustomerSetState() {
  const setCustomer = useContext(CustomerContextSetState);
  return setCustomer;
}


export{
    CustomerProvider,
    useCustomerState,
    useCustomerValue,
    useCustomerSetState,
    useIsCustomer,
}